import { Injectable } from '@angular/core';
@Injectable()
export class LoaderService {
  private _selector: string = 'preloader1'; 
  private _selector1: string = 'preloader2';
  private _selector2:string = 'preloader3' 
  constructor() {   
  } 
  public start(): void {   
     document.getElementById(this._selector).className = 'preloader innerbg displayblock';    
  }
  public stop(): void {   
     document.getElementById(this._selector).className = 'preloader displaynone';  
  }
  public show(): void {   
     
     document.getElementById(this._selector1).className = 'preloader innerbg displayblock';
    // document.getElementById(this._selector2).className = 'loaderc displayblock';
  }
  public hide(): void {   
     document.getElementById(this._selector1).className = 'preloader displaynone';
    // document.getElementById(this._selector2).className = 'loaderc displaynone';
  }
}